import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { MatButton } from '@angular/material/button';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';

@Component({
  selector: 'lib-registration-app-bar',
  standalone: true,
  imports: [MatButton, MatToolbar, MatToolbarRow],
  templateUrl: './registration-app-bar.html',
  styleUrl: './registration-app-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationAppBar {
  public logout = output();
}
